/*
 * @Author: yangchong
 * @Description: 协同办公多语言配置包
 * @Date: 2019-11-30 15:15:06
 */
export default {
  '序号': '序号',
  '其他平台': '其他平台',
  '自动获取': '自动获取',
  '丽晶360终端物流': '丽晶360终端物流',
  'POS自动填充收银员账号&密码': 'POS自动填充收银员账号&密码',
  '协同平台设置': '协同平台设置',
  '平台名称': '平台名称',
  '网址': '网址',
  '输入平台名称': '输入平台名称',
  '输入网址': '输入网址',
  '需填写http': '需填写http',
  '确定删除该记录吗？': '确定删除该记录吗？',
  '新增成功': '新增成功',
  '保存成功': '保存成功',
  '请输入平台名称': '请输入平台名称',
  '请输入网址': '请输入网址',
  '请输入正确的网址': '请输入正确的网址',
  '删除成功': '删除成功',
  '新增': '新增',
  '储位系统': '储位系统',
  '店铺储位管理系统': '店铺储位管理系统',
  '自定义排序': '自定义排序',
  '是否取消自定义排序？': '是否取消自定义排序？',
  '已经是第一条，不可上': '已经是第一条，不可上',
  '已经是最后一条，不可下移': '已经是最后一条，不可下移',
  '修改成功': '修改成功',
  '取消': '取消',
  '保存': '保存',
  '平台类型': '平台类型',
  '外挂': '外挂',
  'RP': 'RP'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/collaboraivePlatform.js